import {
    useCallback,
} from 'react'

import LaneGroupRequests from 'app/requests/ContractBasis/LaneGroup/LaneGroup.requests'
import useSimpleApiRequest from 'app/hooks/useSimpleApiRequest'
import Button from 'app/shared-components/Button'
import ButtonContainer from 'app/shared-components/ButtonContainer'
import useLaneGroupContext from 'app/Apps/Pricing/LaneGroups/hooks/useLaneGroupContext'

import LaneFeesForm from '../LaneFeesForm'
import LaneFeesSetStatusButtons from '../LaneFeesSetStatusButtons'
import useGetDefaultLaneFeesData from '../hooks/useGetDefaultLaneFeesData'

export default function LaneFeesCreate({
    onSuccess, onCancel,
}: Readonly<{
    onSuccess?: (newValue: { id: number }) => void,
    onCancel?: () => void
}>) {
    const {
        laneGroupId,
    } = useLaneGroupContext()

    const {
        mutate: create,
        isPending,
    } = useSimpleApiRequest({
        onSuccess,
        name: 'LaneFeesCreate',
        requestParams: LaneGroupRequests.createLaneFee({
            laneGroupId,
        }),
        title: 'Lane Fees Created',
    })
    const defaultData = useGetDefaultLaneFeesData({
        laneGroupId,
    })

    const getActionButtonsPanel = useCallback(({
        value, isValid, edited,
    }) => {
        return (
            <ButtonContainer>
                <LaneFeesSetStatusButtons
                    key="set-status-buttons"
                    value={value}
                    onCreate={create}
                    disabled={!isValid || !edited}
                    isLoading={isPending}
                />
                <Button
                    disabled={!edited || isPending}
                    secondary
                    label="Cancel"
                    onClick={onCancel}
                />
            </ButtonContainer>
        )
    }, [
        create,
        isPending,
        onCancel,
    ])

    return (
        <LaneFeesForm
            data={defaultData}
            getActionButtonsPanel={getActionButtonsPanel}
        />
    )
}
